<template>
  <div id="container">
    <p class="owner-balance-count">
      <strong class="owner-balance-text"
        >YOUR ZOOM SCORE <img
          id="zoom-score-popover"
          class="czxp-logo"
          src="@/assets/zoom_score_icon.png"
          alt="zoom coin"
          align="middle"
        /></strong
      >
      {{ getZoomScore.toLocaleString() }}
    </p>
    <p class="owner-balance-count">
      <strong class="owner-balance-text">YOUR ZOOMBIES NFTS <img
          id="crypt-nft-popover"
          class="czxp-logo"
          src="./assets/zoombies_nft_icon.webp"
          alt="zoom coin"
          align="middle"
        /></strong> {{ getNftOwned.toLocaleString() }}
    </p>
    <p class="owner-balance-count">
      <strong class="owner-balance-text">YOUR BOOSTER MINTING CREDITS <img
          id="crypt-credits-popover"
          class="czxp-logo"
          src="./assets/lightning.png"
          alt="zoom coin"
          align="middle"
        /></strong> {{ getBoosterCreditOwned.toLocaleString() }}
    </p>
    <b-popover :show="getURLFolder() == 'shop' && Progression.stepIndex==3 && Progression.storyIndex==2" target="zoom-score-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.shop[3].popovers[2].content }}
      </div>
    </b-popover>
    <b-popover :show="getURLFolder() == 'my-zoombies-nfts' && Progression.stepIndex==1 && Progression.storyIndex==1" target="crypt-nft-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.myZoombiesNfts[1].popovers[1].content }}
      </div>
    </b-popover>
    <b-popover :show="getURLFolder() == 'my-zoombies-nfts' && Progression.stepIndex==2 && Progression.storyIndex==1" target="crypt-credits-popover" triggers="manual hover" placement="top" custom-class="header-popover">
      <div class="header-popover-description">
        {{ storyInstructions.myZoombiesNfts[2].popovers[1].content }}
      </div>
    </b-popover>
  </div>
</template>
<script>
import { BPopover } from "bootstrap-vue";
import dAppStates from "@/dAppStates";
import { mapGetters } from "vuex";
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "OwnerBalances",
  computed: {
    isWalletConnected() {
      return this.$store.state.dAppState === dAppStates.WALLET_CONNECTED;
    },
    ...mapGetters({
      getNftOwned: "blockChain/getNftOwned",
      getZoomBalance: "blockChain/getZoomBalance",
      getZoomScore: "blockChain/getZoomScore",
      getBoosterCreditOwned: "blockChain/getBoosterCreditOwned",
    }),
  },
  data() {
    return {
      storyInstructions,
      Progression,
    };
  },
  components: {
    BPopover,
  },
  methods: {
    getURLFolder() {
      return window.location.pathname.split("/")[2];
    }
  },
};
</script>
<style scoped lang="scss">
#container {
  margin: 20px 0;
}

p {
  padding-left: 10px;
  margin-bottom: 0;
  color: pink;

  strong {
    color: aqua;
    font-weight: 400;
  }
}

.owner-balance-count {
  font-family: "Truculenta", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #B2F1FF;
}

.owner-balance-text {
  font-family: "Truculenta", sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #00D1FF;
}

.czxp-logo {
  width: 32px;
}

@media screen and (min-width: 600px) {
  .row-col {
    align-items: flex-start;
  }
}
</style>
